import type { DestinationChain } from './useWithdrawalDestinationTokens'

/** Deduped, curated order intact. */
export function receivableTokens(chains: DestinationChain[]): string[] {
  return [...new Set(chains.flatMap((chain) => chain.symbols))]
}
